import { useKeyboardAwareDrawerStyle } from "@hooks/useKeyboardAwareDrawerStyle";
import { Drawer, DrawerContent } from "@shadcn/ui/drawer";
import type { ComponentProps } from "react";

type DistributiveOmit<T, K extends keyof T> = T extends T ? Omit<T, K> : never;

type KeyboardAwareDrawerProps = DistributiveOmit<ComponentProps<typeof Drawer>, "repositionInputs">;

type KeyboardAwareDrawerContentProps = ComponentProps<typeof DrawerContent> & {
	keyboardAware?: boolean;
};

export const KeyboardAwareDrawer = (props: KeyboardAwareDrawerProps) => {
	return <Drawer repositionInputs={false} {...props} />;
};

export const KeyboardAwareDrawerContent = (props: KeyboardAwareDrawerContentProps) => {
	const { keyboardAware = true, style, ...contentProps } = props;
	const keyboardAwareStyle = useKeyboardAwareDrawerStyle(keyboardAware);

	return <DrawerContent style={keyboardAwareStyle ? { ...style, ...keyboardAwareStyle } : style} {...contentProps} />;
};
